import { ApplicationState } from '~/store/store';

export const getGoodsState = (state: ApplicationState) => state.room.data.goods;
